import {
  UniqueRouteLeg,
  useGetOutboundTransportUniqueRoute,
  useUpdateOutboundSingleOrderRoute,
} from "@/hooks/useTransport";
import { ReactNode, useState } from "react";
import RouteWizard from "./RouteWizard";

export default function OutboundOrderRouteWizard({
  children,
  orderId,
  departureId,
  arrivalId,
  arrivalName,
  byTransportCategory,
  year,
}: {
  children: ReactNode;
  orderId: string;
  departureId: number;
  arrivalId?: number;
  arrivalName: string;
  byTransportCategory: boolean;
  year?: number;
}) {
  const saveMutation = useUpdateOutboundSingleOrderRoute();
  const [isOpen, setIsOpen] = useState(false);

  const { data, isLoading } = useGetOutboundTransportUniqueRoute({
    departureId,
    arrivalId,
    arrivalName,
    byTransportCategory,
    enabled: isOpen,
    year,
    orderId,
  });

  const onSave = (route: UniqueRouteLeg[]) => {
    return saveMutation
      .mutateAsync({
        orderId,
        departureId,
        arrivalId,
        arrivalName,
        byTransportCategory,
        route: { route },
      })
      .then(() => {
        setIsOpen(false);
      });
  };

  return (
    <>
      <span onClick={() => setIsOpen(true)}>{children}</span>
      {isOpen && (
        <RouteWizard
          loading={isLoading}
          onClose={() => setIsOpen(false)}
          route={data?.route}
          departure={data?.departure}
          arrival={data?.arrival}
          count={data?.total_count}
          isOpen={isOpen}
          arrivalType={!!arrivalId ? "facility" : "customer"}
          onSave={onSave}
          isSaving={saveMutation.isLoading}
        />
      )}
    </>
  );
}
